import $axios from "../../api";

// P26_048 Article Tag (menu Articles > Article Tag). Endpoint: ArticleTagController.
const PREFIX = "website/article-tag";

const state = {
    isLoading: false,
    createLoading: false,
    errors: "",
    isSuccess: false,
    list: [],
    page: 1,
    detail: null,
    // Topik Terkini (FR-03): current list for the n/10 button and popup, and the tag search.
    trending: { max: 10, tags: [] },
    trendingOptions: [],
};

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    SET_ERRORS(state, payload) {
        state.errors = payload;
    },
    // Drop the messages of fields the user just changed; the rest stay until the next save.
    CLEAR_ERRORS(state, fields) {
        if (!state.errors || typeof state.errors !== "object") return;
        const next = { ...state.errors };
        (fields || []).forEach((field) => delete next[field]);
        state.errors = next;
    },
    SET_SUCCESS(state, payload) {
        state.isSuccess = payload;
    },
    SET_LIST(state, payload) {
        state.list = payload;
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    SET_CREATE_LOAD(state, payload) {
        state.createLoading = payload;
    },
    SET_DETAIL(state, payload) {
        state.detail = payload;
    },
    SET_TRENDING(state, payload) {
        state.trending = payload;
    },
    SET_TRENDING_OPTIONS(state, payload) {
        state.trendingOptions = payload;
    },
};

const actions = {
    getList({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return $axios
            .get(`${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`)
            .then((response) => {
                commit("SET_LIST", response.data.data);
            })
            .catch((error) => {
                dispatch("Main/globalSweetAlert", error.response, { root: true });
            })
            .finally(() => commit("SET_LOADING", false));
    },
    getDetail({ commit, dispatch }, id) {
        commit("SET_LOADING", true);
        commit("SET_DETAIL", null);
        return $axios
            .get(`${PREFIX}/view?id=${id}`)
            .then((res) => {
                commit("SET_DETAIL", res.data.data);
            })
            .catch((error) => {
                dispatch("Main/globalSweetAlert", error.response, { root: true });
            })
            .finally(() => commit("SET_LOADING", false));
    },
    // create / update resolve on success and reject on failure, so the form can show the
    // "Tag Berhasil Dibuat!" dialog only after the server accepted the tag (AC-01.7).
    // Field errors (422) go to state.errors and appear under each input, not in a popup.
    saveData({ commit, dispatch }, { isUpdate, payload }) {
        commit("SET_SUCCESS", false);
        commit("SET_ERRORS", "");
        commit("SET_CREATE_LOAD", true);
        return $axios
            .post(`${PREFIX}/${isUpdate ? "update" : "create"}`, payload)
            .then((response) => {
                commit("SET_SUCCESS", true);
                return response.data;
            })
            .catch((error) => {
                if (error.response?.status === 422 && error.response.data?.errors) {
                    commit("SET_ERRORS", error.response.data.errors);
                } else {
                    dispatch("Main/globalSweetAlert", error.response, { root: true });
                }
                throw error;
            })
            .finally(() => commit("SET_CREATE_LOAD", false));
    },
    showHide({ commit, dispatch }, payload) {
        commit("SET_SUCCESS", false);
        return $axios
            .post(`${PREFIX}/showhide`, payload)
            .then((response) => {
                commit("SET_SUCCESS", true);
                dispatch("Main/globalSuccessSweetAlert", response.data.message, { root: true });
            })
            .catch((error) => {
                dispatch("Main/globalSweetAlert", error.response, { root: true });
            });
    },
    // Rejects on failure so the popup can keep Save disabled instead of saving a stale list.
    getTrending({ commit, dispatch }) {
        return $axios
            .get(`${PREFIX}/trending`)
            .then((res) => commit("SET_TRENDING", res.data.data))
            .catch((error) => {
                dispatch("Main/globalSweetAlert", error.response, { root: true });
                throw error;
            });
    },
    // "Pilih Tag" in the popup: active master tags (same endpoint as the article form).
    getTrendingOptions({ commit, dispatch }, find) {
        const query = find ? `?find=${encodeURIComponent(find)}` : "";
        return $axios
            .get(`select/article-tag${query}`)
            .then((res) => commit("SET_TRENDING_OPTIONS", res.data.data))
            .catch((error) => dispatch("Main/globalSweetAlert", error.response, { root: true }));
    },
    // Resolves only when the server saved, so the success dialog follows a real save (AC-03.4).
    saveTrending({ dispatch }, tagIds) {
        return $axios
            .post(`${PREFIX}/trending-save`, { tag_ids: tagIds })
            .catch((error) => {
                dispatch("Main/globalSweetAlert", error.response, { root: true });
                throw error;
            });
    },
    // Delete Guard refusals come back as 422 with a message naming the reason (AC-01.10).
    deleteData({ commit, dispatch }, payload) {
        commit("SET_SUCCESS", false);
        return $axios
            .post(`${PREFIX}/delete`, payload)
            .then((response) => {
                commit("SET_SUCCESS", true);
                dispatch("Main/globalSuccessSweetAlert", response.data.message, { root: true });
            })
            .catch((error) => {
                dispatch("Main/globalSweetAlert", error.response, { root: true });
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
